<template>
  <v-card outlined>
    <v-card-title>
      Настройки ProDelivery
    </v-card-title>
    <v-card-text>
      <v-form ref="prodelivery_settings" v-model="form_valid">
        <v-container fluid>
          <v-row dense>
            <v-col>
              <TextField
                label="IP адрес"
                placeholder="___.___.___.___"
                maxlength="15"
                v-model="shop.ip"
                :original_value="original_value ? original_value.ip : undefined"
                :rules="[rules.required, rules.ipRule]"
              />
            </v-col>
            <v-col>
              <TextField
                label="Порт"
                type="number"
                v-model="shop.port"
                :original_value="original_value ? original_value.port : undefined"
                :rules="[rules.portRule]"
              />
            </v-col>
            <v-col cols="12">
              <TextField
                label="Токен"
                v-model="shop.token"
                :original_value="original_value ? original_value.token : undefined"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn
          :disabled="!form_valid"
          color="primary"
          @click="check_connection(local_restaraunt_connection)"
          >Проверить соединение</v-btn
        > -->
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import TextField from '../../ui/TextField.vue';
import rules_mixin from '@/mixins/rules_mixin.js'

export default{

  props: {
    restaurant_connection: Object,
    value: Object,
    original_value: Object,
  },

  mixins: [rules_mixin],

  data: () => ({
    form_valid: true,
    canSave: false,
    local_restaraunt_connection: {
      ip: null,
      port: null,
      token: null,
    },
  }),

  computed:{
    shop:{
      set(v){
        this.$emit('input', v)
      },
      get(){
        return this.value
      }
    }
  },

  methods: {
    checkConnection(restaurantConnection) {
      try {
        console.log(restaurantConnection);
        this.updateRestaurantConnection(restaurantConnection);
      } catch (e) {
        this.canSave = false;
      }
    },

    check_connection(restaurantConnection) {
      this.$emit("update-connection", restaurantConnection);
    },
  },

  mounted() {
    this.local_restaraunt_connection = { ...this.restaurant_connection };
  },

  components:{
    TextField
  }
}
</script>